export const asyncForEach = async (array, callback) => {
	if (array && Array.isArray(array))
		for (let index = 0; index < array.length; index++) {
			await callback(array[index], index, array);
		}
};
